import FormControl from '@mui/material/FormControl'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs from 'dayjs'
import 'dayjs/locale/en-gb'

type DatePickerProps = {
    name: string
    label: string
    value?: string
    onChange: (name: string, value: string) => void
    errorText?: string
    size?: 'small' | 'medium'
    maxValue?: dayjs.Dayjs
    minValue?: dayjs.Dayjs
    disabled?: boolean
}

function CustomDateTimePicker({
    name,
    label,
    value,
    onChange,
    errorText,
    size = 'medium',
    disabled = false,
    maxValue = dayjs(Date.now()),
    minValue,
}: DatePickerProps) {
    return (
        <FormControl fullWidth>
            <LocalizationProvider
                adapterLocale="en-gb"
                dateAdapter={AdapterDayjs}
            >
                <DateTimePicker
                    maxDate={maxValue}
                    minDate={minValue}
                    slotProps={{
                        textField: {
                            variant: 'outlined',
                            error: !!errorText,
                            helperText: errorText,
                            size,
                            InputLabelProps: {
                                sx: {
                                    '&.Mui-focused': {
                                        color: '#434a73',
                                        fontWeight: 500,
                                    },
                                },
                            },
                            inputProps: {
                                readOnly: true,
                            },
                        },
                        inputAdornment: { sx: { marginRight: '1.5%' } },
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#434a73',
                            },
                            '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#434a73',
                            },
                        },
                        '&:hover label': {
                            color: '#434a73',
                        },
                        '.MuiPickersDay-today': {
                            color: '#1565c0',
                            borderRadius: '20px',
                            borderWidth: '0px',
                            borderColor: '#2196f3',
                            border: '0px solid',
                            backgroundColor: '#90caf9',
                        },
                    }}
                    label={label}
                    value={value ? dayjs(value, 'YYYY-MM-DD[T]HH:mm:[00]') : null}
                    onChange={(newValue) => {
                        newValue && onChange(name, newValue?.format('YYYY-MM-DD[T]HH:mm:[00]'))
                    }}
                    disabled={disabled}
                    className={disabled ? 'pointer-events-none' : ''}
                />
            </LocalizationProvider>
        </FormControl>
    )
}

export default CustomDateTimePicker
